import React from 'react';

import { Filter, FilterProps, TextInput } from 'react-admin';

export const TagsFilter: React.FC<Omit<FilterProps, 'children'>> = props => (
  <Filter {...props}>
    <TextInput label="Name" source="name" />
  </Filter>
);
